
import React, { Suspense, lazy } from 'react'
import Banner from "../components/Banner";


const Faq = lazy(() => import("../components/Faq"));
const Features = lazy(() => import("../components/Features"));
const Documentation = lazy(() => import("../components/Documentation"));
const Solutions = lazy(() => import("../components/Solutions"));
const Footer = lazy(() => import("../components/Footer"));

function Homepage() {

  return (
    <Suspense fallback={<>Loading...</>}>
      <main>
        <Banner />
        <Features />
        <Solutions />
        <Documentation />
        <Faq />
      </main>
      <Footer />
    </Suspense>
  );
}

export default Homepage;
